import { css } from '@emotion/css';
import type { ReactNode } from 'react';
import React from 'react';
import { GRAY200 } from '@/domain/colors';

const styles = {
  container: css`
    align-items: center;
    display: flex;
    padding: 16px;
    width: 100%;
    background: ${GRAY200};
    flex-wrap: nowrap;
  `,
  bannerContent: css`
    margin-left: 12px;
    font-size: 16px;
  `,
};

export interface PromotionBannerProps {
  content: ReactNode;
  image: ReactNode;
  className?: string;
}

export const PromotionBanner = (props: PromotionBannerProps) => {
  return (
    <div className={`${styles.container} margin-vertical-xxl ${props.className}`} data-testid='promotion-banner'>
      {props.image}
      <div className={styles.bannerContent}>{props.content}</div>
    </div>
  );
};
